import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Link,
  Card,
  CardContent,
} from "@mui/material";
import { PRIMARY, SECONDARY } from "../theme/theme";
import EmailIcon from "@mui/icons-material/Email";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function Support() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Contact Support
        </Typography>

        <Typography variant="body1" paragraph>
          Need help with the MicroLearning app? Our support team is here to
          assist you with any questions or issues you might have.
        </Typography>

        <Card
          sx={{
            mb: 4,
            border: `1px solid ${PRIMARY}20`,
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <EmailIcon sx={{ color: PRIMARY, fontSize: 28 }} />
              <Typography variant="h6" component="h2">
                Email Support
              </Typography>
            </Box>

            <Typography variant="body1" paragraph>
              For all support inquiries, please email us at:
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                my: 2,
                bgcolor: "rgba(128, 0, 32, 0.05)",
                borderRadius: 2,
                border: `1px solid ${PRIMARY}20`,
              }}
            >
              <Link
                href="mailto:help@blueberrybytes.com"
                sx={{
                  color: PRIMARY,
                  fontWeight: 700,
                  fontSize: "1.25rem",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                <EmailIcon />
                help@blueberrybytes.com
              </Link>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              We aim to respond to all inquiries within 24-48 business hours.
            </Typography>
          </CardContent>
        </Card>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
          }}
        >
          <Card sx={{ flex: 1, borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <HelpOutlineIcon sx={{ color: SECONDARY }} />
                <Typography variant="h6" component="h3">
                  Common Questions
                </Typography>
              </Box>
              <Typography variant="body2" paragraph>
                For frequently asked questions about the app, please check our
                FAQ section in the app.
              </Typography>
            </CardContent>
          </Card>

          <Card sx={{ flex: 1, borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <InfoOutlinedIcon sx={{ color: SECONDARY }} />
                <Typography variant="h6" component="h3">
                  App Information
                </Typography>
              </Box>
              <Typography variant="body2" paragraph>
                Include your device model and app version when contacting
                support for faster assistance.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Paper>
    </Container>
  );
}
